import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import OllieNoticedRows from 'src/components/ollie/OllieNoticedRows'
import { OLLIE_NOTICED_PAGES } from 'src/utils/ollieNoticedRows'
import styled from 'styled-components'
import { stripTransientProps } from 'src/utils/stripTransientProps'
import {
  FoodSafetyHeaderRow,
  FoodSafetyHeroBand,
  FoodSafetyPageTitle,
} from 'src/components/food-safety/FoodSafetyPageChrome'
import {
  Tabs,
  Card,
  Button,
  List,
  Popconfirm,
  Input,
  Collapse,
  Empty,
  Tag,
  Tooltip,
  Modal,
} from 'antd'
import RecipeManager from './components/RecipeManager'
import ShareChangeWithGroup from './components/ShareChangeWithGroup'
import ShareWithGroupButton from './components/ShareWithGroupButton'
import ProductModal from './components/ProductModal'
import RecipeDetails from './components/RecipeDetails'
import MenusTab from './components/MenusTab'
import AllergenGridTab from './components/AllergenGridTab'
import ProductAllergensTab from './components/ProductAllergensTab'
import { useDispatch, useSelector } from 'react-redux'
import {
  createRecipe,
  deleteRecipe,
  duplicateRecipe,
  editRecipe,
  archiveRecipe,
  restoreRecipe,
  fetchAllRecipes,
  fetchCategories,
  getProducts,
  markRecipeReviewed,
  toggleRecipePin,
  // setRecipes,
} from 'src/features/RecipeBuilderSlice'
import {
  fetchAllMenus,
  createMenu,
  updateMenu,
  deleteMenu,
  duplicateMenu,
  archiveMenu,
  restoreMenu,
} from 'src/features/MenuBuilderSlice'
import { fetchVenueProducts } from 'src/features/VenueProductsSlice'
import {
  DeleteOutlined,
  SearchOutlined,
  CopyOutlined,
  LoadingOutlined,
  ShareAltOutlined,
} from '@ant-design/icons'
import { claimSend } from 'src/utils/recipeShareResult'
import {
  AllRecipesDownloadButton,
  DownloadIngredientsCsvButton,
  RecipeDownloadButton,
} from './components/ui/DownloadPdfRecipe'
import useIsBlocked from 'src/hooks/useIsBlocked'
import useSilentStaleEconomicsRepair from 'src/hooks/useSilentStaleEconomicsRepair'
import PermissionBlockScreen from 'src/components/shared/PermissionBlockScreen'
import {
  canStartFirstRecipeCreate,
  parseGrowthEngineSuggestedProduct,
  shouldOpenProgressRecipeCreateHandoff,
} from 'src/utils/growthEngineSuggestedProduct'
import {
  filterRecipesUsingProduct,
  readMenuBuilderUsingProduct,
} from 'src/utils/ollieActionDeepLinks'
import useGrowthEngineFeatureGuidance from 'src/hooks/useGrowthEngineFeatureGuidance'
import useGrowthEngineSuggestedData from 'src/hooks/useGrowthEngineSuggestedData'
import useGrowthEngineRecipesWalkthrough from 'src/hooks/useGrowthEngineRecipesWalkthrough'
import GrowthEngineFeatureEmptyState from 'src/components/growthEngine/GrowthEngineFeatureEmptyState'
import GrowthEngineProgressAskOllie from 'src/components/growthEngine/GrowthEngineProgressAskOllie'
import GrowthEngineRecipesWalkthrough from 'src/components/growthEngine/GrowthEngineRecipesWalkthrough'
import { resolveProgressAskOllie } from 'src/utils/growthEngineProgressAskOllie'
import {
  shouldHideFirstTryMarketingBanners,
  shouldKeepRecipesShoppingListBanner,
} from 'src/utils/growthEngineOneJobPage'
import { shouldHideRecipesWalkthroughOnCreateModal } from 'src/utils/growthEngineWalkthrough'
import {
  canShowRecipesCreateChrome,
  getFirstSuccessCompletion,
  getRecipesEmptyCopy,
  resolveRecipesNeedProductPath,
  shouldShowFirstSuccessCompletion,
  shouldShowRecipesGuidedEmpty,
} from 'src/utils/growthEngineRecommendation'
import GrowthEngineFirstSuccessCompletion from 'src/components/growthEngine/GrowthEngineFirstSuccessCompletion'
import useJustAchievedFirstSuccess from 'src/hooks/useJustAchievedFirstSuccess'
import {
  bindGuidedEmptySuggestedActions,
  pickAcceptedSuggestedItem,
} from 'src/utils/growthEngineSuggestedData'
import ShareRecipeModal from './components/ui/ShareRecipeModal'
import { getIngredientsWithEmptyConversionLabels } from './utils/recipeShareConversionValidation'
import {
  filterRecipesByGpBand,
  formatRecipePanelHeader,
  countRecipesByGpBand,
  formatGpBandFilterLabel,
  GP_BAND_FILTER_OPTIONS,
  GP_CHANGED_FILTER_STYLE,
  GP_FILTER_CHANGED,
  formatGpChangedFilterLabel,
} from 'src/utils/filterRecipes'
import RecipeEconomicsStaleBanner from './components/RecipeEconomicsStaleBanner'
import {
  countRecipesWithStaleEconomics,
  getRecipeEconomicsStaleState,
} from 'src/utils/recipeEconomicsStale'
import { getGpBandByKey, GP_COLOUR_GUIDE_TEXT } from 'src/utils/recipeGp'
import {
  countRecipesNeedingGpReview,
  recipeNeedsGpReview,
} from 'src/utils/recipeGpReview'
import {
  RECIPE_LIST_STATUS,
  RECIPE_LIST_STATUS_OPTIONS,
  filterRecipesByListStatus,
  formatRecipeListEmpty,
  formatRecipeMonitoringHeader,
  isRecipeArchived,
  recipeArchiveNotice,
  recipeRestoreNotice,
  splitLiveAndArchivedRecipes,
} from 'src/utils/recipeMonitoring'
import {
  getRecipePlanAllowance,
  recipeArchiveOverageLine,
} from 'src/constants/recipePlanAllowances'
import {
  recipeArchiveConfirmTitle,
  recipeDuplicateCues,
} from 'src/utils/recipeDuplicateTitles'
import { tidyDisplayTitle } from 'src/utils/venueName'
import {
  menuBuilderShoppingListCopy,
  menuBuilderPinCopy,
  menuBuilderGpReviewCopy,
} from 'src/constants/menuBuilderCopy'
import RecipeListItemTitle from './components/RecipeListItemTitle'
import RecipeListItemDescription from './components/RecipeListItemDescription'
import MenuBuilderListHeader from './components/MenuBuilderListHeader'
import MenuBuilderSinceLookBanner from './components/MenuBuilderSinceLookBanner'
import useMenuBuilderSinceLook from 'src/hooks/useMenuBuilderSinceLook'
import useUserRole from 'src/hooks/useUserRole'
import { useVenueCustomRoles } from 'src/hooks/useIsBlocked'
import { canSeeDashboardTopNav } from 'src/utils/permissions'
import {
  buildShoppingListProductIdSet,
  hasRecipeMissingProducts,
} from 'src/utils/menuBuilderMissingProducts'
import {
  filterPinnedRecipes,
  isRecipePinned,
} from 'src/utils/menuBuilderPinnedRecipes'
import {
  RejectedNotification,
  SuccessNotification,
} from 'src/notifications/SuccessNotification'
import { introCollapsedByDefault } from 'src/utils/introCollapsedByDefault'

const TabPane = Tabs.TabPane
const { Panel } = Collapse

const DashboardContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  width: 100%;

  .ant-card,
  .ant-collapse {
    border: 1px solid #e4efc8;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(19, 45, 7, 0.04);
    background: #fff;
    overflow: hidden;
  }

  .ant-card-head,
  .ant-collapse-header {
    border-bottom: 1px solid #e4efc8;
    color: #132d07;
  }

  .ant-tabs-bar {
    border-bottom-color: #e4efc8;
  }

  .ant-tabs-tab-active {
    color: #132d07;
    font-weight: 600;
  }

  .ant-tabs-ink-bar {
    background: #5a9e0b;
  }
`

const HeroCopy = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 16px;
`

const HeroIntro = styled.p`
  margin: 8px 0 0;
  font-size: 0.95rem;
  line-height: 1.45;
  color: #555;

  a {
    color: #7cb305;
  }
`

const GridContainer = styled.div`
  display: grid;
  // grid-template-columns: 1fr 2fr;

  gap: 24px;
  margin-bottom: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
export const Banner = styled.div`
  background: linear-gradient(180deg, #f7fbec 0%, #ffffff 85%);
  color: #132d07;
  font-family: 'Poppins', sans-serif;
  font-weight: 500;
  padding: 16px;
  text-align: left;
  font-size: 15px;
  border: 1px solid #e4efc8;
  border-top: 3px solid #b5d922;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 1px 2px rgba(19, 45, 7, 0.04);
  display: flex;
  justify-content: center;

  div {
    max-width: 900px;
    width: 100%;

    p {
      margin-bottom: 10px;
      font-size: 15px;

      &:first-child {
        font-size: 20px;
      }
    }

    ul {
      margin-left: 20px;
      padding-left: 15px;
    }

    li {
      font-size: 15px;
    }

    strong {
      font-weight: 600;
      color: #186a3b;
    }

    em {
      font-style: italic;
    }

    a {
      color: #1b5e20;
      font-weight: 600;
      transition: color 0.3s ease-in-out;
      text-decoration: underline;
    }

    a:hover {
      color: #0f3d15;
      text-decoration: underline;
    }
  }
`

const StyledList = styled(List)`
  max-height: 500px;
  overflow-y: auto;
  padding: 4px 0;
  margin-top: 10px;
`

const RecipeListItemRow = styled(stripTransientProps(List.Item))`
  && {
    background-color: ${({ $needsReview, $economicsStale }) =>
      $needsReview ? '#fffbe6' : $economicsStale ? '#f7fbec' : '#fff'};
    border: 1px solid #e4efc8;
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 12px 14px;
  }
`

const UsingProductRow = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-weight: 600;
  gap: 6px;
  margin: 0 5px 10px;
  scroll-margin-top: 16px;
`

const UsingProductClear = styled.button`
  background: none;
  border: 0;
  color: ${({ theme }) => theme.colours?.seaweedGreen || '#132d07'};
  cursor: pointer;
  font: inherit;
  font-weight: 500;
  padding: 0;
  text-decoration: underline;
`

const GpFilterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 5px 12px;
`

const GpFilterTag = styled(Tag)`
  && {
    margin: 0;
    cursor: pointer;
    border-radius: 999px;
    font-weight: 600;
    padding: 2px 12px;
    line-height: 22px;
  }
`

const StatusFilterButton = styled.button`
  margin: 0;
  cursor: pointer;
  border-radius: 999px;
  border: 1px solid #d9d9d9;
  background: #fafafa;
  color: #666;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  padding: 2px 12px;

  &[aria-pressed='true'] {
    color: #132d07;
    background: #f4fce3;
    border-color: #b5d922;
    font-weight: 700;
  }
`

const RecipeDashboard = () => {
  const history = useHistory()
  const location = useLocation()
  const suggestedProduct = parseGrowthEngineSuggestedProduct(location.search)
  const usingProductKey = location.search
  const usingProduct = useMemo(
    () => readMenuBuilderUsingProduct(usingProductKey),
    [usingProductKey],
  )
  const blocked = useIsBlocked('menu-builder')

  if (blocked) {
    return <PermissionBlockScreen />
  }

  const dispatch = useDispatch()
  const venueId = useSelector(state => state.venue?.venue?._id)
  const catalogueProductGatePath =
    resolveRecipesNeedProductPath(venueId) || `/v/${venueId}/catalogue`
  const venueTitle = useSelector(state => state.venue?.venue?.title)
  const venueAllergensLastUpdatedAt = useSelector(
    state => state.venue?.venue?.allergensLastUpdatedAt,
  )
  const venueAllergensLastUpdatedBy = useSelector(
    state => state.venue?.venue?.allergensLastUpdatedBy,
  )
  const usageLimits =
    useSelector(state => state.venue?.venue?.usageLimits) ?? {}
  const currentPlan = usageLimits?.currentPlan || 'Free'
  const {
    recipes,
    recipeAllowance,
    categories,
    products,
    isLoading: recipesLoading,
  } = useSelector(state => state.recipes)
  const venueProductsFromStore = useSelector(
    state => state.venueProducts?.products || [],
  )
  const venueProductsLoading = useSelector(state =>
    Boolean(state.venueProducts?.isLoading),
  )
  const { menus, isLoading: menusLoading } = useSelector(state => state.menus)
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [selectedRecipe, setSelectedRecipe] = useState(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [listStatus, setListStatus] = useState(RECIPE_LIST_STATUS.ALL)
  const [gpBandFilter, setGpBandFilter] = useState(null)
  const [update, setUpdate] = useState(false)
  const [shareOffer, setShareOffer] = useState(null)
  const closeShareOffer = useCallback(() => setShareOffer(null), [])
  const [showShareRecipeModal, setShowShareRecipeModal] = useState(false)
  const [activeTab, setActiveTab] = useState('recipes')
  const userRole = useUserRole()
  const customRoles = useVenueCustomRoles()
  const canSeePlans = canSeeDashboardTopNav(
    'subscriptions',
    userRole,
    customRoles,
  )
  const sinceLook = useMenuBuilderSinceLook(venueId, activeTab === 'recipes')

  const showSinceLookRecipes = () => {
    setListStatus(RECIPE_LIST_STATUS.ALL)
    setGpBandFilter(GP_FILTER_CHANGED)
  }

  const showStoredRecipes = () => {
    setListStatus(RECIPE_LIST_STATUS.ARCHIVED)
    setGpBandFilter(null)
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('gpChanged') !== '1') return
    setActiveTab('recipes')
    setGpBandFilter(GP_FILTER_CHANGED)
  }, [location.search])
  const [bannerToggledCollapsed, setBannerCollapsed] = useState(null)
  const bannerCollapsed = introCollapsedByDefault({
    userChoice: bannerToggledCollapsed,
    hasData: Array.isArray(recipes) && recipes.length > 0,
  })
  const [startSuggestedProduct, setStartSuggestedProduct] = useState(null)
  const [requestOpenCreate, setRequestOpenCreate] = useState(0)
  const [createModalOpen, setCreateModalOpen] = useState(false)
  const [progressCreateProductsReady, setProgressCreateProductsReady] =
    useState(false)
  const recipeDetailAnchorRef = useRef(null)
  const shouldScrollToRecipeDetailsRef = useRef(false)
  const duplicatingRef = useRef(false)
  const [duplicatingRecipeId, setDuplicatingRecipeId] = useState(null)
  const [monitoringRecipeId, setMonitoringRecipeId] = useState(null)
  const handleDuplicateRecipe = async recipeIdToCopy => {
    if (!claimSend(duplicatingRef)) return
    setDuplicatingRecipeId(recipeIdToCopy)
    try {
      await dispatch(duplicateRecipe(venueId, recipeIdToCopy))
    } finally {
      duplicatingRef.current = false
      setDuplicatingRecipeId(null)
    }
  }
  const handleArchiveRecipe = async recipeId => {
    setMonitoringRecipeId(recipeId)
    try {
      const response = await dispatch(archiveRecipe(recipeId, venueId))
      dispatch(fetchAllMenus(venueId))
      const notice = recipeArchiveNotice(response)
      if (notice.warning) {
        Modal.info({
          title: notice.message,
          content: notice.description,
          okText: 'OK',
        })
      } else {
        SuccessNotification(notice)
      }
    } catch (error) {
      RejectedNotification({
        message:
          error?.response?.data?.message ||
          error?.message ||
          'Could not store this recipe',
      })
    } finally {
      setMonitoringRecipeId(null)
    }
  }
  const handleRestoreRecipe = async recipeId => {
    setMonitoringRecipeId(recipeId)
    try {
      const response = await dispatch(restoreRecipe(recipeId, venueId))
      dispatch(fetchAllMenus(venueId))
      const notice = recipeRestoreNotice(response)
      if (notice.blocked) {
        Modal.warning({
          title: 'Not monitored',
          content: notice.message,
          okText: 'OK',
        })
      } else if (notice.message) {
        SuccessNotification({
          message: notice.message,
          duration: notice.duration,
        })
      }
    } catch (error) {
      RejectedNotification({
        message:
          error?.response?.data?.message ||
          error?.message ||
          'Could not monitor this recipe',
      })
    } finally {
      setMonitoringRecipeId(null)
    }
  }
  const guidedSuccess = useGrowthEngineFeatureGuidance({
    venueId,
    surface: 'recipes',
    featureId: 'recipes',
    product: suggestedProduct?.title,
  })
  const showRecipesGuidedEmpty = shouldShowRecipesGuidedEmpty({
    recipes,
    guidedSuccess,
    loading: recipesLoading,
  })
  const shoppingListProducts =
    Array.isArray(products) && products.length
      ? products
      : venueProductsFromStore || []
  const hasShoppingListProducts = shoppingListProducts.length > 0
  const allowRecipesCreateChrome =
    canShowRecipesCreateChrome(shoppingListProducts)
  const recipesEmpty = getRecipesEmptyCopy({
    products: shoppingListProducts,
    emptyState: guidedSuccess?.emptyState,
  })
  const hideFirstTryMarketing = shouldHideFirstTryMarketingBanners(
    showRecipesGuidedEmpty || Boolean(suggestedProduct?.fromProgress),
  )
  const keepShoppingListBanner =
    !suggestedProduct?.fromProgress &&
    shouldKeepRecipesShoppingListBanner({
      showGuidedEmpty: showRecipesGuidedEmpty,
      hasShoppingListProducts,
    })
  const suggested = useGrowthEngineSuggestedData({
    venueId,
    featureId: 'recipes',
    items: guidedSuccess?.suggestedData?.items,
  })
  const walkthrough = useGrowthEngineRecipesWalkthrough({
    venueId,
    guidedSuccess,
    suggestedItems: suggested.visibleItems,
  })
  const recipeSuggestedProduct = startSuggestedProduct || suggestedProduct
  const progressRecipeHandoffDoneRef = useRef(false)

  const beginFirstRecipe = item => {
    if (recipesEmpty.needsProductFirst) {
      const path = resolveRecipesNeedProductPath(venueId)
      if (path) history.push(path)
      return
    }
    if (
      !canStartFirstRecipeCreate({
        item,
        suggestedProduct: startSuggestedProduct || suggestedProduct,
        products: shoppingListProducts,
        hasExistingRecipes: Array.isArray(recipes) && recipes.length > 0,
      })
    ) {
      return
    }
    const pick = pickAcceptedSuggestedItem(item)
    if (pick?.title || pick?.productId) {
      setStartSuggestedProduct({
        title: pick.title || '',
        productId: pick.productId || null,
      })
    } else {
      setStartSuggestedProduct(null)
    }
    const pickedStep =
      pick && walkthrough.currentStep?.id === 'pick_what_you_buy'
        ? walkthrough.completeStep(walkthrough.currentStep.id)
        : null
    if (!pickedStep?.ok) {
      walkthrough.open()
    }
    setRequestOpenCreate(count => count + 1)
  }
  const suggestedEmpty = bindGuidedEmptySuggestedActions({
    venueId,
    featureId: 'recipes',
    suggested,
    onStart: beginFirstRecipe,
  })
  const firstSuccessCompletion = getFirstSuccessCompletion(guidedSuccess)
  const [justAchievedFirstRecipe, setJustAchievedFirstRecipe] =
    useJustAchievedFirstSuccess({
      loading: recipesLoading,
      isEmpty: !Array.isArray(recipes) || recipes.length === 0,
      hasOutcome: Boolean(firstSuccessCompletion?.outcome),
    })
  const showFirstSuccessCompletion = shouldShowFirstSuccessCompletion({
    justAchieved: justAchievedFirstRecipe,
    guidedSuccess,
  })

  const renderRecipesWalkthrough = () =>
    walkthrough.visible &&
    !shouldHideRecipesWalkthroughOnCreateModal(createModalOpen) ? (
      <GrowthEngineRecipesWalkthrough
        step={walkthrough.currentStep}
        stepIndex={walkthrough.stepIndex}
        stepCount={walkthrough.stepCount}
        needsResume={walkthrough.needsResume}
        isLast={walkthrough.isLast}
        allowNext={walkthrough.allowNext}
        showStepCount={walkthrough.showStepChrome}
        onNext={walkthrough.next}
        onSkip={walkthrough.skip}
        onResume={() => {
          walkthrough.resume()
          beginFirstRecipe()
        }}
      />
    ) : null

  const handleViewRecipeDetails = recipe => {
    shouldScrollToRecipeDetailsRef.current = true
    setSelectedRecipe(recipe)
  }

  // Progress create=1: load shopping-list products before opening Create so
  // empty recipe lists do not flash “No recipes found” without a modal.
  useEffect(() => {
    if (!suggestedProduct?.fromProgress || !venueId) {
      setProgressCreateProductsReady(false)
      return undefined
    }
    const wantsCreate =
      Boolean(suggestedProduct.openCreate) ||
      Boolean(suggestedProduct.title) ||
      Boolean(suggestedProduct.productId)
    if (!wantsCreate) {
      setProgressCreateProductsReady(false)
      return undefined
    }
    let cancelled = false
    setProgressCreateProductsReady(false)
    const loadProgressCreateProducts = async () => {
      try {
        await dispatch(fetchVenueProducts(venueId))
      } catch (_err) {
        // Empty list is fine — handoff still decides create vs catalogue.
      } finally {
        if (!cancelled) setProgressCreateProductsReady(true)
      }
    }
    loadProgressCreateProducts()
    return () => {
      cancelled = true
    }
  }, [
    suggestedProduct?.fromProgress,
    suggestedProduct?.openCreate,
    suggestedProduct?.title,
    suggestedProduct?.productId,
    venueId,
    dispatch,
  ])

  useEffect(() => {
    if (!suggestedProduct?.fromProgress) return
    if (progressRecipeHandoffDoneRef.current) return
    if (recipesLoading) return

    const recipeId = suggestedProduct.recipeId
    if (recipeId && Array.isArray(recipes) && recipes.length) {
      const named = recipes.find(recipe => String(recipe._id) === recipeId)
      if (named) {
        progressRecipeHandoffDoneRef.current = true
        setActiveTab('recipes')
        handleViewRecipeDetails(named)
        return
      }
    }

    if (
      suggestedProduct.openCreate ||
      suggestedProduct.title ||
      suggestedProduct.productId
    ) {
      if (
        !shouldOpenProgressRecipeCreateHandoff({
          suggestedProduct,
          recipesLoading,
          venueProductsLoading,
          productsReady: progressCreateProductsReady,
          allowCreate: allowRecipesCreateChrome,
          needsProductFirst: recipesEmpty.needsProductFirst,
        })
      ) {
        return
      }
      progressRecipeHandoffDoneRef.current = true
      setActiveTab('recipes')
      beginFirstRecipe()
      return
    }

    // Review / approaching-limit: skip marketing, open the first named dish.
    if (Array.isArray(recipes) && recipes.length) {
      progressRecipeHandoffDoneRef.current = true
      setActiveTab('recipes')
      handleViewRecipeDetails(recipes[0])
    }
  }, [
    suggestedProduct,
    recipesLoading,
    recipes,
    shoppingListProducts,
    venueProductsLoading,
    progressCreateProductsReady,
    allowRecipesCreateChrome,
    recipesEmpty.needsProductFirst,
  ])

  useLayoutEffect(() => {
    if (!selectedRecipe || !shouldScrollToRecipeDetailsRef.current) return
    shouldScrollToRecipeDetailsRef.current = false
    recipeDetailAnchorRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }, [selectedRecipe])

  useEffect(() => {
    if (selectedRecipe && recipes?.length) {
      const updatedRecipe = recipes.find(
        ({ _id }) => _id === selectedRecipe?._id,
      )
      setSelectedRecipe(updatedRecipe)
    }
  }, [recipes])

  const recipesUsingProduct = useMemo(
    () => filterRecipesUsingProduct(recipes || [], usingProduct),
    [recipes, usingProduct],
  )

  const monitoredRecipes = useMemo(
    () =>
      (recipesUsingProduct || []).filter(recipe => !isRecipeArchived(recipe)),
    [recipesUsingProduct],
  )

  const needsReviewCount = useMemo(
    () => countRecipesNeedingGpReview(monitoredRecipes),
    [monitoredRecipes],
  )

  const gpBandCounts = useMemo(
    () => countRecipesByGpBand(monitoredRecipes),
    [monitoredRecipes],
  )

  const usingProductRowRef = useRef(null)
  const usingProductScrolledRef = useRef(null)
  useEffect(() => {
    if (!usingProduct || recipesLoading || !recipes?.length) return
    if (usingProductScrolledRef.current === usingProductKey) return
    usingProductScrolledRef.current = usingProductKey
    usingProductRowRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    })
  }, [usingProduct, usingProductKey, recipesLoading, recipes])

  const recipeById = useMemo(
    () => new Map((recipes || []).map(recipe => [recipe._id, recipe])),
    [recipes],
  )

  const filteredRecipes = useMemo(() => {
    const query = searchTerm.trim().toLowerCase()
    let result = filterRecipesByListStatus(recipes || [], listStatus)

    if (query) {
      result = result.filter(recipe =>
        recipe.title.toLowerCase().includes(query),
      )
    }

    result = filterRecipesUsingProduct(result, usingProduct)
    result = filterRecipesByGpBand(
      result.filter(recipe => !gpBandFilter || !isRecipeArchived(recipe)),
      gpBandFilter,
    )

    return result
  }, [recipes, searchTerm, gpBandFilter, usingProduct, listStatus])

  const duplicateCues = useMemo(
    () => recipeDuplicateCues(filteredRecipes),
    [filteredRecipes],
  )

  const favouriteRecipes = useMemo(
    () => filterPinnedRecipes(filteredRecipes),
    [filteredRecipes],
  )

  const liveRecipes = useMemo(
    () => (recipes || []).filter(recipe => !isRecipeArchived(recipe)),
    [recipes],
  )

  const monitoringLine = useMemo(() => {
    if (recipeAllowance) return formatRecipeMonitoringHeader(recipeAllowance)
    if (recipesLoading) return null
    const { monitorMax, storeMax } = getRecipePlanAllowance(currentPlan)
    return formatRecipeMonitoringHeader({
      storedCount: recipes?.length || 0,
      storedMax: storeMax,
      monitoredCount: liveRecipes.length,
      monitoredMax: monitorMax,
    })
  }, [recipeAllowance, recipesLoading, currentPlan, recipes, liveRecipes])

  const venueProductsCatalog = useMemo(() => {
    const merged = new Map()
    const add = vp => {
      if (!vp) return
      if (vp._id) merged.set(`vp:${String(vp._id)}`, vp)
      if (vp.product?._id) merged.set(`cat:${String(vp.product._id)}`, vp)
    }
    venueProductsFromStore.forEach(add)
    products.forEach(add)
    return [...merged.values()]
  }, [venueProductsFromStore, products])

  const economicsStaleContext = useMemo(
    () => ({
      recipeById,
      venueProductsCatalog,
    }),
    [recipeById, venueProductsCatalog],
  )

  const staleEconomicsCount = useMemo(
    () => countRecipesWithStaleEconomics(liveRecipes, economicsStaleContext),
    [liveRecipes, economicsStaleContext],
  )

  const recipeIdsWithStaleEconomics = useMemo(() => {
    const ids = new Set()
    liveRecipes.forEach(recipe => {
      if (getRecipeEconomicsStaleState(recipe, economicsStaleContext).isStale) {
        ids.add(recipe._id)
      }
    })
    return ids
  }, [liveRecipes, economicsStaleContext])

  const shoppingListProductIds = useMemo(
    () => buildShoppingListProductIdSet(venueProductsCatalog),
    [venueProductsCatalog],
  )

  const recipeIdsWithMissingProducts = useMemo(() => {
    const ids = new Set()
    ;(recipes || []).forEach(recipe => {
      if (hasRecipeMissingProducts(recipe, shoppingListProductIds)) {
        ids.add(recipe._id)
      }
    })
    return ids
  }, [recipes, shoppingListProductIds])

  const recipeIdsWithSharedMissingIngredients = useMemo(() => {
    const ids = new Set()
    ;(recipes || []).forEach(recipe => {
      if (recipe?.needsIngredientReview) {
        ids.add(recipe._id)
      }
    })
    return ids
  }, [recipes])

  const staleEconomicsRecipeIds = useMemo(
    () => [...recipeIdsWithStaleEconomics],
    [recipeIdsWithStaleEconomics],
  )

  useSilentStaleEconomicsRepair({
    venueId,
    staleRecipeIds: staleEconomicsRecipeIds,
    enabled:
      activeTab === 'recipes' &&
      !recipesLoading &&
      Boolean(recipes?.length) &&
      venueProductsCatalog.length > 0,
  })

  const toggleGpBandFilter = bandKey => {
    setGpBandFilter(current => (current === bandKey ? null : bandKey))
  }

  const handleTogglePin = async recipe => {
    const willPin = !isRecipePinned(recipe)

    try {
      await dispatch(toggleRecipePin(recipe._id, venueId, willPin))
    } catch {
      RejectedNotification({ message: menuBuilderPinCopy.errorMessage })
    }
  }

  const handleMarkReviewed = async recipe => {
    try {
      await dispatch(markRecipeReviewed(recipe._id, venueId))
    } catch {
      RejectedNotification({
        message: menuBuilderGpReviewCopy.markReviewedErrorMessage,
      })
    }
  }

  const handleSaveRecipe = newRecipe => {
    dispatch(createRecipe(venueId, newRecipe))

    // if (newRecipe.id) {
    //   setRecipes(recipes.map((r) => (r.id === newRecipe.id ? newRecipe : r)));
    // } else {
    //   setRecipes([...recipes, { ...newRecipe, id: Date.now().toString() }]);
    // }
  }

  // console.log('recipes ---> ', recipes)
  // console.log('selectedRecipe ----> ', selectedRecipe)

  const closeProductModal = () => {
    setSelectedProduct(null)
  }

  const handleEditRecipe = async recipeData => {
    const saved = await dispatch(
      editRecipe(recipeData?._id, recipeData, venueId),
    )
    if (saved && recipeData?._id) {
      setShareOffer({ kind: 'recipe', venueId, recipeId: recipeData._id })
    }
  }

  const handleAllergenUpdate = async (options = {}) => {
    try {
      // Ingredient/conversion saves already upsert affected recipes in Redux.
      // Skip the expensive full venue recipe reload unless explicitly required.
      if (options?.skipFullRecipeReload) {
        return
      }
      await dispatch(fetchAllRecipes(venueId))
    } catch (error) {
      console.error('Error refreshing allergen data:', error)
    }
  }

  useEffect(() => {
    if (!venueId) return

    dispatch(getProducts(venueId))
    dispatch(fetchAllRecipes(venueId))
    dispatch(fetchCategories(venueId))
  }, [dispatch, venueId])

  useEffect(() => {
    if (!venueId) return
    if (activeTab !== 'menus' && activeTab !== 'allergens') return
    if (menus?.length || menusLoading) return

    dispatch(fetchAllMenus(venueId))
  }, [dispatch, venueId, activeTab, menus?.length, menusLoading])

  useEffect(() => {
    if (!venueId) return
    if (activeTab !== 'allergens' && activeTab !== 'product-allergens') return
    if (venueProductsFromStore.length) return

    dispatch(fetchVenueProducts(venueId))
  }, [dispatch, venueId, activeTab, venueProductsFromStore.length])

  const handleShareRecipeClick = recipe => {
    const invalidIngredients = getIngredientsWithEmptyConversionLabels(recipe)

    if (invalidIngredients.length > 0) {
      Modal.error({
        title: 'Cannot share recipe yet',
        width: 520,
        content: (
          <div>
            <p style={{ marginBottom: 12 }}>
              One or more ingredients use a conversion without a label. Please
              edit the recipe, fix the conversion for each ingredient below,
              then try sharing again.
            </p>
            <ul style={{ paddingLeft: 20, margin: 0 }}>
              {invalidIngredients.map(item => (
                <li key={`${item.sku}-${item.title}`}>
                  <strong>{item.title}</strong>
                  {item.sku ? ` (${item.sku})` : ''}
                </li>
              ))}
            </ul>
          </div>
        ),
      })
      return
    }

    setSelectedRecipe(recipe)
    setShowShareRecipeModal(true)
  }

  // Allergens are calculated on the backend; use recipes from API as-is
  const recipesWithCalculatedAllergens = recipes || []

  // Debug logging for Quick Cocktail
  const quickCocktailRecipe = recipesWithCalculatedAllergens?.find(
    r => r.title === 'Quick Cocktail',
  )
  if (quickCocktailRecipe) {
    // console.log('Quick Cocktail recipe allergens debug:', {
    //   title: quickCocktailRecipe.title,
    //   allergens: quickCocktailRecipe.allergens,
    //   allergenTraces: quickCocktailRecipe.allergenTraces,
    //   customIngredients: quickCocktailRecipe.customIngredients,
    // })
  }

  const dishes =
    recipesWithCalculatedAllergens?.map(recipe => ({
      name: recipe?.title,
      allergens: recipe?.allergens || [],
      allergenTraces: recipe?.allergenTraces || [],
    })) || []

  const uniqueAllergens = [
    ...new Set([
      ...(dishes?.flatMap(({ allergens }) => allergens) || []),
      ...(dishes?.flatMap(({ allergenTraces }) => allergenTraces) || []),
    ]),
  ]

  const renderRecipeListItem =
    ({ useVatAwareSellingPrice = true } = {}) =>
    recipe => {
      const archived = isRecipeArchived(recipe)
      const needsGpReview = !archived && recipeNeedsGpReview(recipe)
      const economicsStale =
        !archived && recipeIdsWithStaleEconomics.has(recipe._id)
      const duplicateCue = duplicateCues.get(String(recipe._id)) || null
      const archiveLabel = duplicateCue
        ? `Store ${
            tidyDisplayTitle(recipe?.title) || 'recipe'
          }. ${duplicateCue}`
        : 'Store'

      return (
        <RecipeListItemRow
          $needsReview={needsGpReview}
          $economicsStale={economicsStale}
          actions={[
            <Button
              key={`${recipe._id}-view`}
              type='link'
              onClick={() => handleViewRecipeDetails(recipe)}
            >
              View Details
            </Button>,
            <Button
              key={`${recipe._id}-share`}
              type='link'
              onClick={event => {
                event.stopPropagation()
                setShareOffer({ kind: 'recipe', venueId, recipeId: recipe._id })
              }}
            >
              Share with group…
            </Button>,
            archived ? (
              <Button
                key={`${recipe._id}-monitor`}
                type='link'
                data-testid='recipe-monitor'
                disabled={Boolean(monitoringRecipeId)}
                onClick={() => handleRestoreRecipe(recipe._id)}
              >
                Monitor
              </Button>
            ) : (
              <Popconfirm
                key={`${recipe._id}-archive`}
                title={recipeArchiveConfirmTitle(recipe, duplicateCue)}
                placement='topRight'
                disabled={Boolean(monitoringRecipeId)}
                onConfirm={() => handleArchiveRecipe(recipe._id)}
                okText='Store'
                cancelText='Cancel'
              >
                <Button
                  type='link'
                  data-testid='recipe-archive'
                  aria-label={archiveLabel}
                  disabled={Boolean(monitoringRecipeId)}
                >
                  Store
                </Button>
              </Popconfirm>
            ),
            <RecipeDownloadButton
              recipe={recipe}
              recipes={recipesWithCalculatedAllergens}
              venueProductsCatalog={venueProductsCatalog}
              allergenMetadata={{
                lastUpdatedAt: venueAllergensLastUpdatedAt,
                lastUpdatedBy: venueAllergensLastUpdatedBy,
              }}
              key={`${recipe._id}-download`}
            />,
            <Popconfirm
              key={`${recipe._id}-delete`}
              title='Are you sure to delete the recipe?'
              placement='topRight'
              onConfirm={() => {
                setSelectedRecipe(null)
                dispatch(deleteRecipe(recipe._id, venueId))
              }}
              okText='Yes'
              cancelText='No'
            >
              <DeleteOutlined style={{ color: 'red', fontSize: 21 }} />
            </Popconfirm>,
            <Popconfirm
              key={`${recipe._id}-duplicate`}
              title='Are you sure to duplicate the recipe?'
              placement='topRight'
              disabled={Boolean(duplicatingRecipeId)}
              onConfirm={() => {
                setSelectedRecipe(null)
                void handleDuplicateRecipe(recipe._id)
              }}
              okText='Yes'
              cancelText='No'
            >
              {duplicatingRecipeId === recipe._id ? (
                <LoadingOutlined
                  data-testid='recipe-duplicating'
                  style={{ fontSize: 20 }}
                />
              ) : (
                <CopyOutlined
                  style={{
                    fontSize: 20,
                    opacity: duplicatingRecipeId ? 0.4 : 1,
                  }}
                />
              )}
            </Popconfirm>,
            <ShareAltOutlined
              key={`${recipe._id}-share`}
              style={{ fontSize: 20, color: '#b5d922' }}
              onClick={() => handleShareRecipeClick(recipe)}
            />,
          ]}
        >
          <List.Item.Meta
            title={
              <RecipeListItemTitle
                recipe={recipe}
                duplicateCue={duplicateCue}
                showMissingProductsBadge={recipeIdsWithMissingProducts.has(
                  recipe._id,
                )}
                showSharedMissingIngredientsBadge={recipeIdsWithSharedMissingIngredients.has(
                  recipe._id,
                )}
                economicsStaleContext={economicsStaleContext}
                onTogglePin={handleTogglePin}
                onMarkReviewed={handleMarkReviewed}
              />
            }
            description={
              <RecipeListItemDescription
                recipe={recipe}
                useVatAwareSellingPrice={useVatAwareSellingPrice}
              />
            }
          />
        </RecipeListItemRow>
      )
    }

  const renderRecipeGroup = (items, itemOptions) => {
    const { live, archived } = splitLiveAndArchivedRecipes(items)
    if (!live.length && !archived.length) return null
    return (
      <>
        {live.length ? (
          <StyledList
            dataSource={live}
            renderItem={renderRecipeListItem(itemOptions)}
          />
        ) : null}
        {archived.length ? (
          <StyledList
            dataSource={archived}
            renderItem={renderRecipeListItem(itemOptions)}
          />
        ) : null}
      </>
    )
  }

  return (
    <DashboardContainer>
      <ShareRecipeModal
        showShareRecipeModal={showShareRecipeModal}
        setShowShareRecipeModal={setShowShareRecipeModal}
        recipeId={selectedRecipe?._id}
      />
      <FoodSafetyHeroBand>
        <FoodSafetyHeaderRow>
          <HeroCopy>
            <FoodSafetyPageTitle>
              Recipe Management Dashboard
            </FoodSafetyPageTitle>
            {keepShoppingListBanner ? (
              <HeroIntro>
                <strong>
                  {menuBuilderShoppingListCopy.dashboardBannerLead}
                </strong>{' '}
                {
                  menuBuilderShoppingListCopy.dashboardBannerBeforeCataloguesLink
                }
                <Link to={catalogueProductGatePath}>Catalogues</Link>
                {menuBuilderShoppingListCopy.dashboardBannerBetweenLinks}
                <Link to={`/v/${venueId}/suppliers`}>Your Suppliers</Link>.
              </HeroIntro>
            ) : null}
          </HeroCopy>
          {keepShoppingListBanner ? (
            <Button type='primary'>
              <Link
                to={catalogueProductGatePath}
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                {menuBuilderShoppingListCopy.dashboardBannerCataloguesCta}
              </Link>
            </Button>
          ) : null}
        </FoodSafetyHeaderRow>
      </FoodSafetyHeroBand>
      <OllieNoticedRows page={OLLIE_NOTICED_PAGES.MENU_BUILDER} />
      <GrowthEngineProgressAskOllie
        featureId={suggestedProduct?.featureId || 'recipes'}
        enabled={
          Boolean(suggestedProduct?.fromProgress) && !showRecipesGuidedEmpty
        }
      />
      {hideFirstTryMarketing ? null : (
        <Collapse
          activeKey={bannerCollapsed ? [] : ['banner']}
          onChange={keys => setBannerCollapsed(keys.length === 0)}
          style={{ marginBottom: 20 }}
        >
          <Panel
            header={
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
              >
                <span>🎉</span>
                <strong>Recipe Management Made Simple!</strong>
              </div>
            }
            key='banner'
          >
            <Banner>
              <div style={{ textAlign: 'left', maxWidth: '900px' }}>
                <p>
                  {`Want to build your menu, control your costs, and track gross profit –`}{' '}
                  <em>without spreadsheets</em>? {`You're in the right place.`}
                </p>
                <a
                  href='https://www.loom.com/share/e978ba16c4c54b17b8b33a06fc73d6cc'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    padding: '10px 16px',
                    backgroundColor: '#1b5e20',
                    color: 'white',
                    borderRadius: '6px',
                    fontWeight: 600,
                    fontSize: '16px',
                    textDecoration: 'none',
                    marginBottom: '16px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  }}
                >
                  ▶️&nbsp;Watch 2-Min Demo
                </a>

                <p>
                  💡 <strong>This tool helps you:</strong>
                </p>
                <ul style={{ marginLeft: 20 }}>
                  <li>Track GP % for each dish</li>
                  <li>
                    See ingredient prices update in real time from invoices &
                    supplier files
                  </li>
                  <li>Compare costs across suppliers</li>
                  <li>Build a scalable, profitable menu</li>
                </ul>

                <p>
                  💌 Any questions or ideas to improve this feature? Drop us a
                  line at{' '}
                  <a href='mailto:info@ordersmadesimple.com'>
                    info@ordersmadesimple.com
                  </a>
                </p>
              </div>
            </Banner>
          </Panel>
        </Collapse>
      )}

      <Tabs
        defaultActiveKey='recipes'
        activeKey={activeTab}
        onChange={setActiveTab}
      >
        <TabPane tab='Recipes' key='recipes'>
          <GridContainer>
            <div style={{ display: 'flex' }}>
              <RecipeManager
                products={shoppingListProducts}
                categories={categories}
                recipes={recipes}
                onSaveRecipe={handleSaveRecipe}
                onAllergenUpdate={handleAllergenUpdate}
                suggestedProduct={recipeSuggestedProduct}
                requestOpenCreate={requestOpenCreate}
                onCreateModalOpenChange={setCreateModalOpen}
                allowCreate={allowRecipesCreateChrome}
              />
              <AllRecipesDownloadButton
                recipes={filteredRecipes}
                venueProductsCatalog={venueProductsCatalog}
                allergenMetadata={{
                  lastUpdatedAt: venueAllergensLastUpdatedAt,
                  lastUpdatedBy: venueAllergensLastUpdatedBy,
                }}
              />
              <DownloadIngredientsCsvButton
                recipes={recipesWithCalculatedAllergens}
                venueTitle={venueTitle}
              />
            </div>

            <Card
              title='Recipe List'
              extra={
                <ShareWithGroupButton
                  offer={{ kind: 'categories', venueId }}
                  label='Share categories…'
                />
              }
            >
              <MenuBuilderSinceLookBanner
                banner={sinceLook}
                canSeePlans={canSeePlans}
                onShowRecipes={showSinceLookRecipes}
                onShowStored={showStoredRecipes}
                onSeePlans={() =>
                  history.push(`/v/${venueId}/subscriptions/oms-plans`)
                }
              />
              {showFirstSuccessCompletion ? (
                <GrowthEngineFirstSuccessCompletion
                  outcome={firstSuccessCompletion.outcome}
                  nextSummary={firstSuccessCompletion.nextSummary}
                  ctaLabel={firstSuccessCompletion.ctaLabel}
                  managerOnePager={firstSuccessCompletion.managerOnePager}
                  featureId='recipes'
                  onCta={() => {
                    setJustAchievedFirstRecipe(false)
                    beginFirstRecipe()
                  }}
                  onProgress={
                    venueId
                      ? () => history.push(`/v/${venueId}/progress`)
                      : undefined
                  }
                />
              ) : null}
              {!recipes?.length ? (
                <>
                  {showRecipesGuidedEmpty ? (
                    <>
                      <GrowthEngineFeatureEmptyState
                        featureId='recipes'
                        title={recipesEmpty.title}
                        body={recipesEmpty.body}
                        valueLine={recipesEmpty.valueLine}
                        estimatedMinutes={recipesEmpty.estimatedMinutes}
                        honestNote={recipesEmpty.honestNote}
                        ctaLabel={recipesEmpty.label}
                        onCta={suggestedEmpty.onCta}
                        suggestedItems={
                          recipesEmpty.needsProductFirst
                            ? []
                            : suggestedEmpty.suggestedItems
                        }
                        onSuggestedItem={suggestedEmpty.onSuggestedItem}
                        onSuggestedEdit={suggestedEmpty.onSuggestedEdit}
                        onRejectSuggested={suggestedEmpty.onRejectSuggested}
                        askOllieQuestion={
                          suggestedProduct?.fromProgress
                            ? resolveProgressAskOllie(
                                suggestedProduct?.featureId || 'recipes',
                              )?.question
                            : null
                        }
                        askOllieLabel={
                          resolveProgressAskOllie(
                            suggestedProduct?.featureId || 'recipes',
                          )?.label
                        }
                      />
                      {renderRecipesWalkthrough()}
                    </>
                  ) : (
                    <Empty description='No recipes found' />
                  )}
                  {monitoringLine ? (
                    <MenuBuilderListHeader
                      monitoringOnly
                      currentPlan={currentPlan}
                      monitoringLine={monitoringLine}
                      archiveLine={recipeArchiveOverageLine(recipeAllowance)}
                    />
                  ) : null}
                </>
              ) : (
                <>
                  {recipes?.length ? (
                    <MenuBuilderListHeader
                      recipes={liveRecipes}
                      storedCount={(recipes || []).length}
                      currentPlan={currentPlan}
                      usageLimits={usageLimits}
                      monitoringLine={monitoringLine}
                      archiveLine={recipeArchiveOverageLine(recipeAllowance)}
                    />
                  ) : null}

                  <Input
                    prefix={<SearchOutlined />}
                    placeholder='Search by recipe title'
                    allowClear
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    style={{
                      margin: 5,
                      marginBottom: 10,
                      height: 35,
                    }}
                  />

                  {usingProduct ? (
                    <UsingProductRow
                      ref={usingProductRowRef}
                      data-testid='menu-builder-using-product'
                    >
                      <span>
                        {`Recipes using ${
                          usingProduct.title || 'this product'
                        } (${filteredRecipes.length})`}
                      </span>
                      <span aria-hidden='true'>·</span>
                      <UsingProductClear
                        type='button'
                        onClick={() => history.replace(location.pathname)}
                        data-testid='menu-builder-using-product-clear'
                      >
                        Clear
                      </UsingProductClear>
                    </UsingProductRow>
                  ) : null}

                  {recipes?.length ? (
                    <GpFilterRow data-testid='recipe-list-status'>
                      {RECIPE_LIST_STATUS_OPTIONS.map(option => {
                        const active = listStatus === option.key
                        return (
                          <StatusFilterButton
                            key={option.key}
                            type='button'
                            aria-pressed={active}
                            data-testid={`recipe-list-status-${option.key}`}
                            onClick={() => setListStatus(option.key)}
                          >
                            {option.label}
                          </StatusFilterButton>
                        )
                      })}
                    </GpFilterRow>
                  ) : null}

                  {recipes?.length ? (
                    <>
                      <RecipeEconomicsStaleBanner
                        staleCount={staleEconomicsCount}
                      />
                      <GpFilterRow>
                        <Tooltip title={GP_COLOUR_GUIDE_TEXT}>
                          <span
                            style={{
                              alignSelf: 'center',
                              fontSize: 12,
                              color: '#666',
                              marginRight: 4,
                            }}
                          >
                            GP band:
                          </span>
                        </Tooltip>
                        {GP_BAND_FILTER_OPTIONS.map(option => {
                          const isGpChanged = option.key === GP_FILTER_CHANGED
                          const band = isGpChanged
                            ? GP_CHANGED_FILTER_STYLE
                            : getGpBandByKey(option.key)
                          const active = gpBandFilter === option.key
                          const label = isGpChanged
                            ? formatGpChangedFilterLabel(
                                option.label,
                                needsReviewCount,
                              )
                            : formatGpBandFilterLabel(
                                option.label,
                                gpBandCounts[option.key] || 0,
                              )

                          return (
                            <GpFilterTag
                              key={option.key}
                              style={{
                                color: band.color,
                                backgroundColor: active
                                  ? band.backgroundColor
                                  : '#fafafa',
                                borderColor: active ? band.color : '#d9d9d9',
                                fontWeight: active ? 700 : 600,
                              }}
                              onClick={() => toggleGpBandFilter(option.key)}
                            >
                              {label}
                            </GpFilterTag>
                          )
                        })}
                      </GpFilterRow>
                    </>
                  ) : null}

                  <Collapse accordion defaultActiveKey={['all']}>
                    {favouriteRecipes.length > 0 ? (
                      <Panel
                        header={formatRecipePanelHeader(
                          'Favourites',
                          favouriteRecipes.length,
                        )}
                        key='favourites'
                      >
                        {renderRecipeGroup(favouriteRecipes)}
                      </Panel>
                    ) : null}

                    <Panel
                      header={formatRecipePanelHeader(
                        'All',
                        filteredRecipes.length,
                      )}
                      key='all'
                    >
                      {filteredRecipes?.length ? (
                        renderRecipeGroup(filteredRecipes)
                      ) : (
                        <Empty
                          description={formatRecipeListEmpty({
                            listStatus,
                            gpChanged: gpBandFilter === GP_FILTER_CHANGED,
                          })}
                        />
                      )}
                    </Panel>

                    {categories?.length &&
                      categories.map(category => {
                        const recipesInCategory = filteredRecipes.filter(
                          recipe => recipe.category?._id === category._id,
                        )
                        if (!recipesInCategory.length) return null

                        return (
                          <Panel
                            header={formatRecipePanelHeader(
                              category.name,
                              recipesInCategory.length,
                            )}
                            key={category._id}
                          >
                            {renderRecipeGroup(recipesInCategory, {
                              useVatAwareSellingPrice: false,
                            })}
                          </Panel>
                        )
                      })}

                    {(() => {
                      const uncategorisedRecipes = filteredRecipes.filter(
                        recipe => !recipe.category,
                      )
                      if (!uncategorisedRecipes.length) return null

                      return (
                        <Panel
                          header={formatRecipePanelHeader(
                            'Uncategorised',
                            uncategorisedRecipes.length,
                          )}
                          key='uncategorised'
                        >
                          {renderRecipeGroup(uncategorisedRecipes, {
                            useVatAwareSellingPrice: false,
                          })}
                        </Panel>
                      )
                    })()}
                  </Collapse>
                </>
              )}
            </Card>
          </GridContainer>

          {selectedRecipe && (
            <>
              <div
                ref={recipeDetailAnchorRef}
                style={{ scrollMarginTop: 24 }}
              />
              <Button
                onClick={() =>
                  setShareOffer({
                    kind: 'recipe',
                    venueId,
                    recipeId: selectedRecipe._id,
                  })
                }
              >
                Share with group…
              </Button>
              <RecipeDetails
                key={selectedRecipe?._id}
                recipe={selectedRecipe}
                recipes={recipes}
                products={products}
                venueId={venueId}
                handleEdit={() => setUpdate(true)}
                onMissingProductsResolved={handleAllergenUpdate}
                onMarkReviewed={handleMarkReviewed}
              />
              {update && (
                <RecipeManager
                  products={products}
                  categories={categories}
                  recipes={recipes}
                  onSaveRecipe={handleEditRecipe}
                  recipe={selectedRecipe}
                  update={update}
                  setUpdate={setUpdate}
                  onAllergenUpdate={handleAllergenUpdate}
                />
              )}
            </>
          )}
        </TabPane>

        <TabPane tab='Menus' key='menus'>
          <MenusTab
            menus={menus}
            venueRecipes={recipes}
            venueId={venueId}
            venueTitle={venueTitle}
            onMenuAction={(action, menuId, data) => {
              switch (action) {
                case 'create':
                  dispatch(createMenu(venueId, data))
                  break
                case 'update':
                  dispatch(updateMenu(menuId, data, venueId))
                  break
                case 'delete':
                  dispatch(deleteMenu(menuId, venueId))
                  break
                case 'duplicate':
                  dispatch(duplicateMenu(menuId, data.name, venueId))
                  break
                case 'archive':
                  dispatch(archiveMenu(menuId, venueId))
                  break
                case 'restore':
                  dispatch(restoreMenu(menuId, venueId))
                  break
                default:
                  break
              }
            }}
          />
        </TabPane>

        {/* <TabPane tab='Products' key='products'>
          <Card title='Product Catalog'>
            <List
              grid={{ gutter: 16, column: 3 }}
              dataSource={products}
              renderItem={product => (
                <List.Item>
                  <Card hoverable onClick={() => handleProductClick(product)}>
                    <Card.Meta
                      title={product.name}
                      description={`£${product.price.toFixed(2)}`}
                    />
                  </Card>
                </List.Item>
              )}
            />
          </Card>
        </TabPane> */}

        <TabPane tab='Allergen Grids' key='allergens'>
          <AllergenGridTab
            dishes={dishes}
            allergenTypes={uniqueAllergens}
            businessName={venueTitle}
            menus={menus}
            venueId={venueId}
          />
        </TabPane>

        <TabPane tab='Ingredient Allergens' key='product-allergens'>
          <ProductAllergensTab businessName={venueTitle} venueId={venueId} />
        </TabPane>
      </Tabs>

      <ProductModal
        visible={!!selectedProduct}
        onClose={closeProductModal}
        product={selectedProduct}
      />
      {shareOffer ? (
        <ShareChangeWithGroup offer={shareOffer} onClose={closeShareOffer} />
      ) : null}
    </DashboardContainer>
  )
}

export default RecipeDashboard
